export default __webpack_public_path__ + "static/media/products_582.f187c8bb.jpg";